import React from "react";
import "./styles/certificationCollage.css";

const CertificationCollage = () => {
	return (
		<div className="certification-collage">
			<div className="certifications-grid">
				<div className="cert-badge">
					<img
						src="image copy 2.png"
						alt="Google Cloud Certified - Cloud DevOps Engineer"
						className="cert-image"
					/>
				</div>
				<div className="cert-badge">
					<img
						src="image copy.png"
						alt="AWS Certified Developer - Associate"
						className="cert-image"
					/>
				</div>
				<div className="cert-badge">
					<img
						src="image.png"
						alt="Open Source Developer for Enterprise - Certified"
						className="cert-image"
					/>
				</div>
				<div className="cert-badge">
					<img
						src="image copy 3.png"
						alt="AWS Certified DevOps Engineer - Professional"
						className="cert-image"
					/>
				</div>
				<div className="cert-badge">
					<img
						src="image copy 4.png"
						alt="AWS Certified Solutions Architect - Associate"
						className="cert-image"
					/>
				</div>
				<div className="cert-badge">
					<img
						src="image copy 5.png"
						alt="AWS Certified AI Practitioner - Foundational"
						className="cert-image"
					/>
				</div>
			</div>
		</div>
	);
};

export default CertificationCollage;
